<template>
  <div>
    <ReportsDialog

      ref="reportsDialogRef"
      :report-list="reportList"
      :query="reportQuery"
      title="Inventory Reports"
    />
    <list-items
      v-if="isList"
      :title="$translate('master_item')"
      ref="listItemsRef"
    >
      <import-form
        :subject="$translate('inventory')"
        v-model="importModal"
        @cancel="hideModal()"
        :fields="inventoryFields"
        :upload-record="uploadInventoryRecord"
        settings-key-name="inventoryUploadKey"
      ></import-form>

      <div
        class="d-flex gap-1 gap-md-2 ps-3 mt-1 mt-md-0 align-self-baseline align-self-md-center master-item-button"
      >
        <b-button
          id="add-master-item"
          variant="blue-icon"
          v-b-tooltip.hover
          :title="$addLabel()"
          v-if="hasPermissionCreate"
          @click="routePath"
        >
          <img src="@/assets/images/icon/gradient-add.svg" />
        </b-button>

        <b-button
          id="import-master-item-btn"
          variant="blue-icon"
          v-b-tooltip.hover
          :title="$translate('import')"
          @click="importModal = true"
          v-if="hasPermissionCreate"
        >
          <img src="@/assets/images/icon/import.svg" />
        </b-button>

        <b-button
          id="export-master-item-btn"
          variant="blue-icon"
          v-b-tooltip.hover
          :title="$translate('export')"
          @click="showReportDialog"
          v-if="hasPermissionView"
        >
          <img src="@/assets/images/icon/export.svg" />
        </b-button>
        <b-button
          id="master-item-section-btn"
          variant="blue-icon"
          v-b-tooltip.hover
          :title="$translate('sections')"
          @click="toSectionRoutePath"
          v-if="hasPermissionView"
        >
          <img src="@/assets/images/icon/sections.svg" />
        </b-button>
      </div>
    </list-items>
    <view-item @success="alertSuccess" :id="id" v-else></view-item>
  </div>
</template>
<script>
import ListItems from "./ListItems";
import ViewItem from "./ViewItem";
import popupMixins from "@/mixins/popupMixins";
import permissionsMixins from "@/mixins/permissionsMixins";
import ImportForm from "@/components/ImportForm.vue";
import showItemHelper from "@/mixins/showItemHelper";
import importMixins from "@/mixins/importMixins";
import ReportsDialog from "@/components/ReportsDialog";
import { templates } from "@/exports/jsreport_templates";

const inventoryFields = [
  { name: "name", label: "name", required: true, type: "text" },
  {
    name: "reference_code",
    label: "ext_reference_code",
    required: true,
    type: "text",
  },
  {
    name: "external_reference_code",
    label: "ext_ref_code",
    type: "text",
  },
  {
    name: "description",
    label: "description",
    required: false,
    type: "text",
  },
  { name: "vendor", label: "vendor", required: true, type: "text" },
  { name: "uom", label: "uom", required: true, type: "select" },
  {
    name: "selling_price",
    label: "selling_price",
    required: true,
    type: "text",
  },
  {
    name: "item_type_name",
    label: "item_type_name",
    required: true,
    type: "text",
  },
  {
    name: "is_selection_value_type",
    label: "is_selection_value_type",
    required: true,
    type: "text",
  },
  {
    name: "is_selection_value_type_format",
    label: "is_selection_value_type_format",
    required: false,
    type: "text",
    options: [
      { 'value': 0, 'text': 'No'},
      { 'value': 1, 'text': 'Yes'},
    ]
  },
  {
    name: "value_name",
    label: "value_name",
    required: false,
    type: "text",
  },
  {
    name: "value_min",
    label: "value_min",
    required: false,
    type: "text",
  },
  {
    name: "value_max",
    label: "value_max",
    required: false,
    type: "text",
  },
  {
    name: "value_selections",
    label: "value_selections",
    required: false,
    type: "text",
  },
  { 
    name: 'default_value', 
    label: 'default_value', 
    required: false, 
    type: 'text', 
  },
  {
    name : 'default_rental_rate',
    label : 'default_rental_rate',
    required:false,
    type: 'text'
  }

];
export default {
  name: "MasterItems",
  components: {
    ListItems,
    ReportsDialog,
    ViewItem,
    ImportForm,
  },
  mixins: [popupMixins, showItemHelper, permissionsMixins, importMixins],
  data: () => {
    return {
      item: null,
      importModal: false,
      loading: false,
      inventoryFields,
      reportQuery: {},
    };
  },
  created() {
    setTimeout(() => {
    Promise.all([
      this.$store.dispatch("assets/listVendors"),
      this.$store.dispatch("itemType/fetchAll"),
      this.$store.dispatch("orderType/fetchAll"),
      this.$store.dispatch("locations/fetchWarehouses"),
      this.$store.dispatch("masterItem/unit_of_measures"),
    ]);
    }, 500);
  },
  computed: {
    componentName() {
      return this.$translate("master_item");
    },
    items() {
      const items = this.$store.state.masterItem.items;
      console.log("items", items);
      return items;
    },
    user_permissions() {
      return this.$store.getters.user_permissions;
    },

    vendors() {
      return this.$store.state.assets.vendors;
    },

    itemTypes() {
      return this.$store.state.itemType.items;
    },

    unitMeasures() {
      return this.$store.state.masterItem.unit_of_measures;
    },
    reportList() {
      return [
        {
          id: "master-items-report",
          value: templates.RPT_SVR_MAS_DET_TEMPLATE,
          extension: "xlsx",
          name: "master-items-report",
          label: this.$translate("master_items_report_excel"),
        },

        {
          value: templates.RPT_SVR_INVEN_TEMPLATE,
          id: "inventory-report-excel",
          extension: "xlsx",
          name: "Inventory Report Excel",
          label: this.$translate("inventory_report_excel"),
        },

        {
          value: templates.RPT_SVR_INVENDET_TEMPLATE,
          id: "inventory-detail-report-excel",
          extension: "xlsx",
          name: "Inventory Detail Report Excel",
          label: this.$translate("inventory_detail_report_excel"),
        },
      ];
    },
  },
  watch: {
    /* isList: function (value) {
      if (!value) {
        Promise.all([
          this.$store.dispatch("orderType/fetchAll"),
          this.$store.dispatch("assets/listVendors"),
          this.$store.dispatch("locations/fetchWarehouses"),
        ]);
      }
    }, */
  },
  methods: {
    routePath() {
      this.$router.push(`${this.$route.path}/0`);
    },
    toSectionRoutePath() {
      this.$router.push(`/ams/inventory-transfer`);
    },
    alertSuccess(action, message) {
      this.genericToast(
        this.componentName,
        action,
        "success",
        `${this.componentName} ${message}`
      );
      // this.doToast('Success', message, 'success')
    },
    showReportDialog() {
      this.reportQuery =
        this.$refs.listItemsRef && this.$refs.listItemsRef.getReportQuery();
      this.$nextTick(() => {
        this.$refs.reportsDialogRef.show();
      });
    },

    async uploadInventoryRecord(
      dataRecord,
      statusRecord,
      { check, message, field },
      statuses,
      setLoading
    ) {
      try {
        let {
          name,
          reference_code:ext_reference_code,
          description,
          vendor: vendor_name,
          // uom,
          selling_price,
          item_type_name,
          uom,
          active = true,
          is_selection_value_type,
          value_name,
          value_min,
          value_max,
          value_selections,
          default_value,
          external_reference_code,
          default_rental_rate
        } = dataRecord;

        selling_price = Number(selling_price.replace(/[^0-9.-]+/g, ""));

        console.log("selling_price:", selling_price);
        console.log("item_type_name:", item_type_name);

        statusRecord.status = statuses.CHECKING;
        console.log("field", field);

        if (check != 1) throw new Error(`${this.$translate(field)}-${message}`);

        vendor_name = vendor_name || "";
        vendor_name = vendor_name.trim();
        const vendor_id = this.getCustomEntityId(
          vendor_name,
          this.vendors,
          "name",
          "Vendor"
        );

        item_type_name = item_type_name || "";
        item_type_name = item_type_name.trim();
        const order_item_type_id = this.getCustomEntityId(
          item_type_name,
          this.itemTypes,
          "name",
          "Order Item Type"
        );

        const is_selection_value_types = [
          {
            'name': 'Yes',
            'id': 1,
          },
          {
            'name': 'No',
            'id': 0,
          }
        ]

        is_selection_value_type = is_selection_value_type || "";
        is_selection_value_type = is_selection_value_type.trim();
        const is_selection_value_type_option = this.getCustomEntityId(
          is_selection_value_type,
          is_selection_value_types,
          "name",
          "Is Selection Value Type"
        );

        uom = uom || "";
        uom = uom.trim();

        if(value_selections) {
          value_selections = JSON.stringify(value_selections.split(',').map(x => x.trim()))
        } else {
          value_selections = null
        }


        const param = {
          name,
          ext_reference_code,
          description,
          vendor_id,
          uom,
          selling_price,
          order_item_type_id,
          item_type_name,
          active,
          is_selection_value_type: is_selection_value_type_option,
          value_name,
          value_min,
          value_max,
          value_selections: value_selections,
          default_value,
          external_reference_code,
          default_rental_rate
        };
        console.log({ param });

        const res = await this.$store.dispatch("masterItem/create", param);
        console.log("response:", res);
        // set status to complete if the upload was successful
        statusRecord.status = statuses.COMPLETE;
      } catch (err) {
        console.error("err", err);
        statusRecord.error_list =
          typeof err.message == "string"
            ? [["error", [err.message]]]
            : Object.entries(err.message);
        statusRecord.status = statuses.ERROR;
      } finally {
        setLoading(false);
      }
    },
  },
};
</script>
<style></style>
